import glimmothSvg from '@/assets/rewards/creatures/glimmoth.svg';
import pipperelSvg from '@/assets/rewards/creatures/pipperel.svg';
import quilltailSvg from '@/assets/rewards/creatures/quilltail.svg';
import bumblebloomSvg from '@/assets/rewards/creatures/bumblebloom.svg';
import wispwhalSvg from '@/assets/rewards/creatures/wispwhal.svg';
import embergrubSvg from '@/assets/rewards/creatures/embergrub.svg';
import lumibrookSvg from '@/assets/rewards/creatures/lumibrook.svg';
import starmoleSvg from '@/assets/rewards/creatures/starmole.svg';

const CREATURE_SVGS: Record<string, string> = {
  glimmoth: glimmothSvg,
  pipperel: pipperelSvg,
  quilltail: quilltailSvg,
  bumblebloom: bumblebloomSvg,
  wispwhal: wispwhalSvg,
  embergrub: embergrubSvg,
  lumibrook: lumibrookSvg,
  starmole: starmoleSvg,
};

interface CreatureSvgProps {
  speciesId: string;
  size?: number;
  silhouette?: boolean;
  className?: string;
}

export function CreatureSvg({
  speciesId,
  size = 110,
  silhouette = false,
  className = '',
}: CreatureSvgProps) {
  const src = CREATURE_SVGS[speciesId];
  if (!src) return null;

  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      className={`${className} ${silhouette ? '' : 'animate-creature-bob'}`}
      style={{
        objectFit: 'contain',
        ...(silhouette ? { filter: 'brightness(0) opacity(0.18)' } : {}),
      }}
    />
  );
}
